import apiClient from './apiClient';
import mockPermissionService from '../mock/mockPermissionService';

// Determine whether to use the mock service
const useMockService = process.env.REACT_APP_ENABLE_MOCK_API === 'true';

// Service for managing permissions
const permissionService = useMockService
  ? mockPermissionService
  : {
      async getPermissions() {
        try {
          const response = await apiClient.get('/api/permissions');
          return response.data;
        } catch (error) {
          console.error('Failed to fetch permissions', error);
          throw error;
        }
      },
    };

export default permissionService;
